export const HIDDEN = 'HIDDEN'
export const COLOR = 'COLOR'
export const POSITION = 'POSITION'
export const TEXT_EFFECT = 'TEXT_EFFECT'
export const ZOOM = 'ZOOM'
export const DARKEN_LIGHTEN = 'DARKEN_LIGHTEN'
export const AROUND = 'AROUND'
export const POSITION_ZOOM_ALL = 'POSITION_SIZE_ALL'
export const TEXT_SIZE = 'TEXT_SIZE'



// WEBPACK FOOTER //
// ./src/constants/stylePresetType.js